export default {
  methods: {
    $notifications_error(message, title = this.$t('Error')) {
      if (typeof message === 'undefined' || message === null || message.length === 0) {
        // eslint-disable-next-line
        message = this.$t('Unknown error');
      }
      this.$toastr.error(message, title);
    },
    $notifications_success(message, title = this.$t('Success')) {
      this.$toastr.success(message, title);
    },
    $notifications_info(message, title = this.$t('Info')) {
      this.$toastr.info(message, title);
    },
  },
};
